module.exports = __webpack_public_path__ + "static/media/AboutMePhoto.1908f5da.jpg";